import Notification from '../notification';

/**
 * Create the action
 */

const { thunk, request, success, error } = Notification.index((fetch) =>
  fetch.get('/notifications/messages')
);

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
